import utils from './Utils';
function isWechat(){
	var ua = navigator.userAgent.toLowerCase();
	if(ua.match(/MicroMessenger/i)=="micromessenger") {
		return true;
 	} else {
		return false;
	}
}

function isDingDing(){
	var ua = navigator.userAgent;
	if(ua.match(/DingTalk/i)=="DingTalk") {
		return true;
 	} else {
		return false;
	}
}

function isAndroid(){
	var ua = navigator.userAgent;
	if(ua.match(/Android/i)=="Android") {
		return true;
 	} else {
		return false;
	}
}

function isYdgApp(){
	var ua = navigator.userAgent;
	if(ua.match(/ydgApp/i)=="ydgApp") {
		return true;
 	} else {
		return false;
	}
}

export default {


	
	mediaCapture : {
	
	    /**
	     * 拍摄视频
	     */
		captureVideo(successCallback,errorCallback){
			var vjsList = ['vjs.framework.extension.platform.services.native.mobile.mediacapture'];
	        let promise = utils.loadVjs(vjsList);
	        promise.then((sb)=>{
	            var Mediacapture = sb.getService("vjs.framework.extension.platform.services.native.mobile.Mediacapture");
	            if(Mediacapture){
	            	var cb = function(videoObj){
	            		if(videoObj.length > 0 && "string" == typeof videoObj[0].fullPath){
	            			successCallback(videoObj[0].fullPath);
	            		}else{
	            			errorCallback("获取视频路径失败");
	            		}
	            	}
	            	Mediacapture.captureVideo(cb,errorCallback);
	            }else{
	            	alert("请在移动端使用拍摄视频服务");
	            }
	        }).catch(err=>{
	        	errorCallback(err);
	        });
	    }
	},

	imagePicker : {
	
	    /**
	     * 从相册选择文件
	     */
		getPicture(successCallback,errorCallback,options){
			if(!options.maximumImagesCount){
				options.maximumImagesCount = 9;
			}
			if(isWechat()){
				var vjsList = ['vjs.framework.extension.platform.services.native.mobile.image','vjs.framework.extension.platform.native.weixin.image','vjs.framework.extension.platform.services.domain.weixin.sdk.config'];
		        let promise = utils.loadVjs(vjsList);
		        promise.then((sb)=>{
		            var imageService = sb.getService("vjs.framework.extension.platform.services.native.mobile.Image");
		            if(imageService){
		            	imageService.chooseImage({
		            		sizeType: ['compressed'],
		            		count:options.maximumImagesCount,
		            		sourceType: ['album'],
		            		successCallback:successCallback
		            	});
		            }else{
		            	alert("请在微信端使用拍照服务");
		            }
		        }).catch(err=>{
		        	errorCallback(err);
		        });
			}else{
				var vjsList = ['vjs.framework.extension.platform.services.native.mobile.imagepicker'];
		        let promise = utils.loadVjs(vjsList);
		        promise.then((sb)=>{
		            var ImagePicker = sb.getService("vjs.framework.extension.platform.services.native.mobile.ImagePicker");
		            if(ImagePicker){
		            	ImagePicker.getPicture(successCallback,errorCallback,options);
		            }else{
		            	alert("请在移动端使用相册选择服务");
		            }
		        }).catch(err=>{
		        	errorCallback(err);
		        });
			}
	    }
	
	},

	camera : {
	
	    /**
	     * 拍照
	     */
		getPicture(successCallback,errorCallback,options){
			if(!options.maximumImagesCount){
				options.maximumImagesCount = 9;
			}
			if(isWechat()){
				var vjsList = ['vjs.framework.extension.platform.services.native.mobile.image','vjs.framework.extension.platform.native.weixin.image','vjs.framework.extension.platform.services.domain.weixin.sdk.config'];
		        let promise = utils.loadVjs(vjsList);
		        promise.then((sb)=>{
		            var imageService = sb.getService("vjs.framework.extension.platform.services.native.mobile.Image");
		            if(imageService){
		            	var tmpCallback = function(imageids){
		            		if(imageids && imageids.length > 0)
		            			successCallback(imageids[0]);
		            		else{
		            			errorCallback("拍照被取消");
		            		}
		            	}
		            	imageService.chooseImage({
		            		count:options.maximumImagesCount,
		            		sizeType: ['compressed'], 
		            		sourceType: ['camera'],
		            		successCallback:tmpCallback
		            	});
		            }else{
		            	alert("请在微信端使用拍照服务");
		            }
		        }).catch(err=>{
		        	errorCallback(err);
		        });
			}else{
				var vjsList = ['vjs.framework.extension.platform.services.native.mobile.camera'];
		        let promise = utils.loadVjs(vjsList);
		        promise.then((sb)=>{
		            var Camera = sb.getService("vjs.framework.extension.platform.services.native.mobile.Camera");
		            if(Camera){
		            	Camera.getPicture(successCallback,errorCallback,options);
		            }else{
		            	alert("请在移动端使用拍照服务");
		            }
		        }).catch(err=>{
		        	errorCallback(err);
		        });
			}
	    }
	
	},
	
	fileUpload : {
		upload(browse_button ,successCB,errorCB , config){
			if(isDingDing() && isAndroid() && config && config.useCamera && "image/*"==config.fileMimeType){
				vjsList = ["vjs.framework.extension.platform.native.dingding.filetransfer"] ;
				let promise = utils.loadVjs(vjsList);
				 promise.then((sb)=>{
					var h5Filetransfer = sb.getService("vjs.framework.extension.platform.service.native.dingding.Filetransfer");
					if (h5Filetransfer) {
						h5Filetransfer.uploadFiles(browse_button, successCB ,config);
					} else{
						alert("加载vjs【vjs.framework.extension.platform.native.h5.filetransfer】失败,请检查");
					}
				 }).catch(err=>{
					 errorCB(err);
		        });
			}else{
				var vjsList = ["vjs.framework.extension.platform.native.h5.filetransfer"];
				let promise = utils.loadVjs(vjsList);
				 promise.then((sb)=>{
					var h5Filetransfer = sb.getService("vjs.framework.extension.platform.native.h5.Filetransfer");
					if (h5Filetransfer) {
						h5Filetransfer.uploadFiles(browse_button, successCB ,config);
					} else{
						alert("加载vjs【vjs.framework.extension.platform.native.h5.filetransfer】失败,请检查");
					}
				 }).catch(err=>{
					 errorCB(err);
		        });
			}
			
			
			 
		}
	},

	fileTransfer : {
		
		/**
	     * 文件上传
	     * @param context vue实例对象
	     */
		filetransferUpload(fileUrls,callback , context){
			var vjsList = [];
			if(isWechat()){
				vjsList = ['vjs.framework.extension.platform.native.weixin.filetransfer'];
			}else{
				vjsList = ['vjs.framework.extension.platform.services.native.mobile.fileoperation'];
			}
			let promise = utils.loadVjs(vjsList);
	        promise.then((sb)=>{
	        	var FileTransfer;
	        	if(isWechat()){
	        		FileTransfer = sb.getService("vjs.framework.extension.platform.native.weixin.Filetransfer");
				}else{
					FileTransfer = sb.getService("vjs.framework.extension.platform.services.native.mobile.FileTransfer");
				}
	            if(FileTransfer){
	            	var cb = function(success,fileInfos){
	            		var successObj = {
	            				success : true,
	            				errorCode : 0
	            		};
	            		if(!success){
	            			successObj.success = false;
	            			successObj.errorCode = 2;
	    				}else if(success && success.errorCode){
	    					callback(success,fileInfos);
	    				}else{
	    					callback(successObj,fileInfos);
	    				}
	            	}
	            	if(isWechat()){
	            		var scopeId = null ;
	    	        	if(context){
	    	        		scopeId = context.$root._$getScopeId();
	    	        	}
	            		FileTransfer.uploadFiles(fileUrls,cb , scopeId);
	 				}else{
	 					FileTransfer.filetransferUpload(fileUrls,cb);
	 				}
	            	
	            	
	            }else{
	            	alert("请在移动端使用文件上传服务");
	            }
	        }).catch(err=>{
	        	alert("App端文件上传失败："+err);
	        });
	    }
	},

	geoLocation : {

	    /**
	     * 获取当前地理位置
	     * @param config 可选参数。格式：
	     * {
	     * 	baiduMapAK: "百度地图AK码" ,//在非https页面下，用于调用百度地图的ip定位api。
	     * }
	     */
		getCurrentPosition(successCallBack,errorCallBack ,config){
			if(isYdgApp()){
				var vjsList = ['vjs.framework.extension.platform.services.native.mobile.geolocation'];
		        let promise = utils.loadVjs(vjsList);
		        promise.then((sb)=>{
		            var Geolocation = sb.getService("vjs.framework.extension.platform.services.native.mobile.Geolocation");
		            if(Geolocation){
		            	var successCB = function(positionInfo){
		            		var latitudeTmp = positionInfo.coords.latitude;
		            		var longitudeTmp = positionInfo.coords.longitude;
		            		var rs = {
		            				latitude : latitudeTmp,
		            				longitude : longitudeTmp
		            		}
		            		successCallBack(rs);
		            	}
		            	Geolocation.getCurrentPosition(successCB,errorCallBack);
		            }
		        }).catch(err=>{
		        	errorCallback(err);
		        });
			}else{
				var vjsList ;
				if(isDingDing()){
					vjsList = ['vjs.framework.extension.platform.native.dingding.geolocation'];
				}else if(isWechat()){
					vjsList = ['vjs.framework.extension.platform.native.weixin.geolocation'];
				}else{
					vjsList = ['vjs.framework.extension.platform.native.h5.geolocation'];
				}
		        let promise = utils.loadVjs(vjsList);
		        promise.then((sb)=>{
		            var Geolocation = sb.getService("vjs.framework.extension.platform.service.native.mobile.Geolocation");
		            if(Geolocation){
		            	var successCB = function(positionInfo){
		            		var latitudeTmp = positionInfo.coords.latitude;
		            		var longitudeTmp = positionInfo.coords.longitude;
		            		var rs = {
		            				latitude : latitudeTmp,
		            				longitude : longitudeTmp
		            		}
		            		successCallBack(rs);
		            	}
		            	Geolocation.getCurrentPosition(successCB,errorCallBack , config);
		            }else{//正常来说，不会进入这个分支。
		            	alert("内部错误，请联系管理员");
		            	errorCallback("内部错误，请联系管理员");
		            }
		        }).catch(err=>{
		        	errorCallback(err);
		        });
			}
	    }

	},
	
	sdkConfig:{
		getDingTalkConfigObject(apiList , successCB , errorCB ){
			if(isDingDing()){
				var vjsList = ['vjs.framework.extension.platform.native.dingding.sdk.config'];
		        let promise = utils.loadVjs(vjsList);
		        promise.then((sb)=>{
		            var sdkConfig = sb.getService("vjs.framework.extension.platform.service.native.sdk.config");
		            if(sdkConfig){
		            	sdkConfig.initConfig(successCB,errorCB,apiList);
		            }else{
		            	if(typeof errorCB == "function")
		            		errorCB("请在移动端使用本接口");
		            }
		        }).catch(err=>{
		        	errorCallback(err);
		        });
			}
		},
		getServerAddr(){
			if(window.VPlatformPatch&&window.cordova){
				var platformId = cordova.platformId;
				if(platformId == "ios"){
					return VPlatformPatch.getMetadata().serveraddr;
				}else{
					return VPlatformPatch.getMetadata().serverAddr;
				}
			}else{
				alert("请在App中使用本接口");
				return "" ;
			}
			
		}
	},
	network:{
		getNetworkState(successCB , errorCB ){
			var vjsList ;
			if(isDingDing()){
				vjsList = ['vjs.framework.extension.platform.native.dingding.network'];
			}else if(isWechat()){
				vjsList = ['vjs.framework.extension.platform.native.weixin.network'];
			}else{
				vjsList = ['vjs.framework.extension.platform.native.cordova.network'];
			}
	        let promise = utils.loadVjs(vjsList);
	        promise.then((sb)=>{
	        	var networkService = sb.getService("vjs.framework.extension.platform.service.native.Network");
	        	networkService.getNetworkState(successCB , errorCB);
	        });
		},
		registerNetworkStateListener(listener){
			var vjsList ;
			if(isDingDing()){
				vjsList = ['vjs.framework.extension.platform.native.dingding.network'];
			}else if(isWechat()){
				vjsList = ['vjs.framework.extension.platform.native.weixin.network'];
			}else{
				vjsList = ['vjs.framework.extension.platform.native.cordova.network'];
			}
	        let promise = utils.loadVjs(vjsList);
	        promise.then((sb)=>{
	        	var networkService = sb.getService("vjs.framework.extension.platform.service.native.Network");
	        	networkService.registerNetworkStateListener(listener);
	        });
		}
	}
	
}



// WEBPACK FOOTER //
// ./src/Mobile.js